import Box, { type BoxProps } from '@liquidweb-dev/undercurrent/Box';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';
import Card from '@liquidweb-dev/undercurrent/Card';
import CardHeader from '@liquidweb-dev/undercurrent/CardHeader';
import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';

export interface AddonWrapperProps extends StackProps {
	headerLabel?: string;
}

export const AddonIconBox = ({ sx, children, ...rest }: BoxProps) => {
	return (
		<Box
			sx={combineSx(
				({ borderRadius }) => ({
					borderRadius: borderRadius.rounded,
					width: '64px',
					height: '64px',
					justifyContent: 'center',
					alignItems: 'center',
					display: 'flex',
				}),
				sx,
			)}
			{...rest}
		>
			{children}
		</Box>
	);
};

const AddonWrapper = ({
	children,
	headerLabel,
	...rest
}: AddonWrapperProps) => {
	return (
		<Stack {...rest}>
			<Card sx={{ zIndex: 1, width: '100%' }}>
				<CardHeader title={headerLabel || 'Selected Service'} />
				<Box
					sx={{
						position: 'relative',
						display: 'flex',
						flexDirection: 'column',
						padding: 200,
					}}
				>
					{children}
				</Box>
			</Card>
		</Stack>
	);
};

export default AddonWrapper;
